<template>
  <div class="gap-filling">
    <el-form label-position="top" ref="ruleForm" :rules="rules" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="課程版本" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇課程版本">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- <el-col :span="8">
          <el-form-item label="課程版本" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇課程版本">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="8">
          <el-form-item label="難易程度" prop="level">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題及插圖"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <el-form-item label="問題圖片">
        <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="onUploadSuccess"></upload>
        <div class="img-box" v-if="rulesForm.img_url">
          <div class="close" @click="rulesForm.img_url = ''"></div>
          <img :src="rulesForm.img_url" />
        </div>
      </el-form-item>
      <vue-dividing-line title="內容及答案2"></vue-dividing-line>
      <div><i class="el-icon-warning-outline"></i> 將需要填入答案的地方以英文符號@#括住。</div>
      <div><i class="el-icon-warning-outline"></i> 每個填空格只能容納10個數位。</div>
      <Tinymce v-model="topic" ref="Tinymce"></Tinymce>
       
       <vue-dividing-line title="解答思路"></vue-dividing-line>
       <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <LatexRenderer :latexContent="rulesForm.explanation" />
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
          <el-button type="info" @click="openPreviewInNewTab">AI解題</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>

      <div class="mathematical-mathjax" @mousedown.prevent="e => false">
        <vue-mathjax
          :formula="topicCopy || ''"
          :safe="false"
        />
      </div>
    </el-form>
  </div>
</template>

<script>
import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import extractOverContent from '../plugins/extractOverContent'
import { symbol } from '../plugins/directive'
import rules from "../plugins/validator";
import getNodeOffset from '../plugins/getNodeOffset'
import fillSumPlus from '../plugins/fill_sum_plus'
import fillSum from '../plugins/fill_sum'
import LatexRenderer from "@/views/question/components/KaTeXRenderer";
import {getToken} from "@/utils/auth";
import {getDeepseekChat} from "@/api/question";
let pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'

export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { upload,Tinymce,LatexRenderer },
  watch: {
    'topic': function (v) {
      // this.topicCopy = v
      this.topicCopy = this.strConvertDom(v)
      console.log(v)
    }
  },
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,
      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],
      rulesForm: {},
      // rulesForm: {
      //   id: '',
      //   lang: "",
      //   title: "",
      //   img_url: '',
      //   type: 2,
      //   score: 1,
      //   level: 1,
      //   explanation: '',
      //   answers: [],
      //   choices: [],
      //   content: '',
      // },
      rules,
      topicCopy: '',
      topic: '',
      fillList: [
        // {label: 'A', value: '20'},
        // {label: 'B', value: '5'},
      ],
      units: [],
    };
  },
  methods: {
    openPreviewInNewTab() {
      let form = this.handleFromData()
      // 1. 生成预览页面的URL（拼接form参数）
      const previewPath = this.$router.resolve({
        path: '/preview',
        query: {
          form: JSON.stringify(form)
        }
      }).href
      const token = getToken()
      const authorization = `Bearer ${token}`;
      const message = `Authorization=${authorization};URL=${process.env.VUE_APP_HOST_API}${previewPath}`
      // 2. 打开新标签页
      // window.open(previewPath, '_blank')
      let listQuery = {
        message:message,
        lang:form.lang
      }
      getDeepseekChat(listQuery).then((response) => {

        if (!response || !response.data || !response.data.content) {
          console.warn("接口返回数据格式异常，缺少必要的 content 字段");
          this.rulesForm.explanation = null; // 给默认值，避免表单字段为 undefined
          return;
        }
        console.info(response.data)
        this.rulesForm.explanation=response.data.content
      })
    },
    preview() {
      let form = this.handleFromData()
      console.log(form)
      form.type = 2
      this.$emit('preview', form)
    },
    focus() {
      console.log('focus')
    },

    childByVideoUrl(v) {
      this.rulesForm.videoUrl = v;
      this.$forceUpdate();
    },

    removeFill(idx) {
      this.rulesForm.fillList.splice(idx, 1);
    },
    addFill() {
      this.rulesForm.fillList.push({label: '', value: ''})
    },
    onUploadSuccess(url) {
      this.rulesForm.img_url = url;
    },
    strConvertDom(data) {
      let regex = /\$\$([^$]*)\$\$|\$([^$]*)\$/g,
          // regex2 = /\\left\((?!\\left\()[\S+\s+]*?\\right\)|\((?!\\left\(|\\right\)|\(|\))[\S\s]*?\)/g,
          // regex2 = /\([^()|^\\left(|^\\right)]*\)/g,
          regex2 = /@(.*?)#/g,
          regex3 = /#{2}(.*?)#{2}/g,
          regex4 = /\|(.*?)\|/g,
          regex5 = /(&amp;){2}(.*?)(&amp;){2}/g,
          regex02 = data.match(regex2),
          regex03 = data.match(regex3),
          regex05 = data.match(regex5),
          regexMap = {
            over: /\$(([^$]*)\\over([^$]*))\$/,
            frac: /\$(([^$]*)\\frac([^$]*))\$/,
            overline: /\$(([^$]*)\\overline([^$]*))\$/,
            dfrac: /\$(([^$]*)\\dfrac([^$]*))\$/,
            overbrace: /\$(([^$]*)\\overbrace([^$]*))\$/,
          }

      this.valNum = 0
      // console.log(data)
      if(regex05) {
        // console.log(regex05)
        regex05.filter(its => {
          let itsCte = its.replaceAll('&amp;&amp;', '')

          if(regex4.test(itsCte)) {
            let [expression] = itsCte.match(regex4),
                content = itsCte.replace(expression, '')
            let {newCte: equation, pattern} = fillSumPlus(content, expression),
                arithmetic = this.calculate(pattern)
            let echoHtml = `<span class="fill-box"><input type="text" data-arithmetic="${arithmetic}" class="fill ordinary arithmetic"/></span>`
            equation = equation.replaceAll('()', echoHtml)
            data = data.replace(its, `<span>${equation}</span>`)
          }
        })
      }

      /// regex04 必须在regex05之后过滤
      let regex04 = data.match(regex4)
      if(regex04) {
        regex04.filter(its => {
          let equation = fillSum(its)
          // console.log(equation)
          let arithmetic = this.calculate(equation)
          let echoHtml = `<span class="fill-box"><input type="text" data-arithmetic="${arithmetic}" class="fill ordinary arithmetic" /></span>`
          equation = equation.replace('/', '÷').replace('*', 'x').replace('()', echoHtml)
          data = data.replace(its, `<span>${equation}</span>`)
          // console.log(data)
        })
      }

      let regex01 = data.match(regex)
      if(regex01) {
        // console.clear()
        // console.log(regex01)
        regex01.filter(its => {
          let frac = its.match(regexMap.frac)
              , overline = its.match(regexMap.overline)
              , overbrace = its.match(regexMap.overbrace)
              , dfrac = its.match(regexMap.dfrac)

          if(dfrac) {
            console.clear()
            console.log(dfrac)
            // 处理數据 判断是否被()括住
            for(let i = 2; i < dfrac.length; i++) {
              // 过滤出@#包裹的内容 将其替换成生僻字 '龘'
              let val = dfrac[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              dfrac[i] = dfrac[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                console.log(val, '+++++')
                val.filter(its => dfrac[i] = dfrac[i].replace(its, '龘'))
              }
            }

            // otherL, otherR 其他, child 分子, parent 分母
            let [, , otherL, content] = dfrac
                , cte = content.match(/\{([^}]+)\}/g)
                , child = ''
                , parent = ''
                , otherR = content || ''
            console.log(cte)
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  child = r
                  content = content.replace(its, '')
                } else {
                  parent = r
                  content = content.replace(its, '')
                }
              })
            }

            if(child != '' && parent != '') {
              otherR = content
            } else if(child != '') {
              let [p, ...o] = content.split('')
              parent = parent || p
              otherR = o.join('')
            } else {
              let [c, p, ...o] = content.split('')
              child = child || c
              parent = parent || p
              otherR = o.join('')
            }

            console.log(otherL, child, parent, otherR)
            let groups = [otherL, child, parent, otherR]

            for(let g = 0; g < groups.length; g++) {
              let val = groups[g].match(/龘/g)
              if(val) {
                let [prevVal, nextVal] = groups[g].split(val[0])
                groups[g] = {fill: true, val: val, prevVal, nextVal}
              }
              else groups[g] = {fill: false, val: groups[g]}
            }

            let [l, c, p, r] = groups
            let echoHtml = `
              ${
                l.fill ? `${l.prevVal}<div class="fill-box"><input type="text" class="fill ordinary" /></div>${l.nextVal}` : l.val
            }
              <div class="some-as">
                ${ c.fill ?
                `
                    <div class="some-child">
                      <span>${c.prevVal}</span>
                      <div class="fill-box">
                        <input type="text" class="fill numerator">
                      </div>
                      <span>${c.nextVal}</span>
                    </div>
                    ` :
                c.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${c.val}</span>` :
                    `<span class="denominator">${c.val}</span>` }
                <div class="line"></div>
                ${ p.fill ?
                `
                    <div class="some-child">
                      <span>${p.prevVal}</span>
                      <div class="fill-box">
                        <input type="text" class="fill numerator">
                      </div>
                      <span>${p.nextVal}</span>
                    </div>
                    ` :
                p.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${p.val}</span>` :
                    `<span class="denominator">${p.val}</span>` }
              </div>
              ${
                r.fill ? `${r.prevVal}<div class="fill-box"><input type="text" class="fill ordinary" /></div>${r.nextVal}` : r.val
            }
            `
            data = data.replace(its, echoHtml)
          }

          if(overline) {
            console.log(overline)
            // 处理數据 判断是否被()括住
            for(let i = 2; i < overline.length; i++) {
              let val = overline[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              overline[i] = overline[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              console.log(val)
              // if(val) {
              //   let [prevVal, nextVal] = overline[i].split(val[0])
              //   overline[i] = {fill: true, val: val, prevVal, nextVal}
              // }
              // else overline[i] = {fill: false, val: overline[i]}
            }

            // otherL, otherR 其他, content 内容
            let [, , otherL, content] = overline
                , cte = content.match(/\{([^}]+)\}/g)
                , c = ''
                , otherR = content || ''
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  c = r
                  otherR = otherR.replace(its, '')
                } else {
                  otherR = otherR.replace(its, r)
                }
              })
            } else {
              let [f, ...o] = content.split('')
              c = f || ''
              otherR = o.join('')
            }
            console.log(otherR)
            let echoHtml = `
              <div class="overline">
                <span>${otherL}</span>
                <div class="overline-content">${c}</div>
                <span>${otherR}</span>
              </div>
            `
            data = data.replace(its, echoHtml)
          }

          let over = its.match(regexMap.over)
          if(over && !overline && !overbrace) {
            console.log(over)
            // 取出匹配的字符 在进一步过滤
            let newOver = extractOverContent(over[1])
                , to_filter = /{([^{}]*)}/
                , overs = []
            console.log(newOver)
            if(newOver.length != 0) {
              let grade = newOver[0].split('\\over')
              overs = over[1].split(`{${newOver[0]}}`)
              for(let i = grade.length - 1; i >= 0; i--) {
                let otem = grade[i]
                    , matchRes = otem.match(to_filter)
                if(matchRes) {
                  otem = otem.replace(matchRes[0], matchRes[1])
                }
                overs.splice(1, 0, otem)
              }
              console.log('newOver.length != 0')
            } else {
              newOver = over[1].match(to_filter)
              // 判断是否包含\over
              if(newOver && newOver[0].indexOf('\\over') > 0) {
                if(newOver) {
                  overs = over[1].split(newOver[0])
                  overs.splice(1, 0, ...newOver[1].split('\\over'))
                } else {
                  overs = ['', ...over[1].split('\\over'), '']
                }
              } else {
                console.log(over)
                overs = ['']
                for(let i = 2; i < over.length; i++) {
                  let otem = over[i]
                      , matchRes = otem.match(to_filter)
                  if(matchRes) {
                    otem = otem.replace(matchRes[0], matchRes[1])
                  }
                  overs.push(otem)
                }
              }
            }

            console.log(overs)
            // 处理數据 判断是否被()括住
            for(let i = 0; i < overs.length; i++) {
              let val = overs[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              overs[i] = overs[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                let [prevVal, nextVal] = overs[i].split(val[0])
                overs[i] = {fill: true, val: val, prevVal, nextVal}
              }
              else overs[i] = {fill: false, val: overs[i]}
            }

            // child 分子, parent 分母
            let [left, child, parent, right] = overs

            let echoHtml = `
            ${
                left.fill ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : left.val
            }
            <span class="some-as">
              ${ child.fill ?
                `
                  <span class="some-child">
                    <span>${child.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${child.nextVal}</span>
                  </span>
                  ` :
                child.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${child.val}</span>` :
                    `<span class="denominator">${child.val}</span>` }
                <span class="line"></span>
              ${ parent.fill ?
                `
                  <span class="some-child">
                    <span>${parent.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${parent.nextVal}</span>
                  </span>
                  ` :
                parent.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${parent.val}</span>` :
                    `<span class="denominator">${parent.val}</span>`}
            </span>
            ${
                (right && right.fill) ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : (right ? right.val : '')
            }
            `
            data = data.replace(its, echoHtml)
          }

          if(frac) {
            // integer 整数部分，fraction 分数部分
            let [, , integer, fraction] = frac
                , fractionRegex = /\{.*?\}/g
                // 取出同时去除首尾的大括号
                , [child, parent] = fraction.match(fractionRegex)
                    .map(s => s.slice(1, -1))
                , other = fraction.replace(`{${child}}{${parent}}`, '')
            let echoData = [integer, child, parent, other]
            // 处理數据 判断是否被()括住
            for(let i = 0; i < echoData.length; i++) {
              let val = echoData[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              echoData[i] = echoData[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                let [prevVal, nextVal] = echoData[i].split(val[0])
                echoData[i] = {fill: true, val: val, prevVal, nextVal}
              } else echoData[i] = {fill: false, val: echoData[i]}
            }

            let echoHtml = `
            <span class="mixed-number">
              ${ echoData[0].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[0].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill mixed">
                    </span>
                    <span>${echoData[0].nextVal}</span>
                  </span>
                  `:
                echoData[0].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[0].val}</span>` :
                    `<span class="mixed">${echoData[0].val}</span>` }
              <span class="some-as">
                ${ echoData[1].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[1].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${echoData[1].nextVal}</span>
                  </span>
                  `:
                echoData[1].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[1].val}</span>` :
                    `<span class="numerator">${echoData[1].val}</span>`}
                <span class="line"></span>
                ${ echoData[2].fill ?
                `
                  <span class="some-child">
                    <span>${echoData[2].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill denominator">
                    </span>
                    <span>${echoData[2].nextVal}</span>
                  </span>
                  ` :

                echoData[2].val.indexOf('<input') > -1 ?
                    `<span class="some-child">${echoData[2].val}</span>` :
                    `<span class="numerator">${echoData[2].val}</span>`  }
              </span>
            </span>
            ${
                echoData[3].fill ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : echoData[3].val
            }
            `
            data = data.replace(its, echoHtml)
          }
        })

      }

      if(regex02) {
        // console.log(regex02)
        regex02.filter(its => {
          // console.log(its)
          let echoHtml = `<span class="fill-box"><input type="text" oninput="fillingBlanks(event)" class="fill ordinary" /></span>`
          // console.log(echoHtml)
          data = data.replace(its, echoHtml)
          this.valNum ++
        })
      }

      if(regex03) {
        regex03.filter(its => {
          let val = its.replace(/##/g, '')
          let echoHtml = `<span class="fill-box"><span class="fill-not ordinary" value="">${val}</span></span>`
          data = data.replace(its, echoHtml)
        })
      }

      return data.replaceAll(pLeft, '(').replaceAll(pRight, ')')
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { topic } = this, fillList = []
      topic = topic.replaceAll('\\left(', pLeft).replaceAll('\\right)', pRight)
      console.log(topic)
      // fillList
      let regex = /@(.*?)#/g // 匹配带()
      , regex1 = /\|(.*?)\|/g,
      regex01 = topic.match(regex1)
      

      // 处理數据
      form.answers = []
      form.choices = []
      console.log(regex01)
      if(regex01) {
        try {
          regex01.filter(its => {
            its = its.replaceAll('|', '')
            let [pattern] = its.split(',')
            let {empty} = fillSum(its, true)
            topic = topic.replace(its, '')
            console.log(empty)
            for(let i = 0; i < empty; i ++) {
              form.answers.push({value: ''})
              let answersLetter = pattern.match(/\(([a-z])\)/g)
  
              if(answersLetter) {
                answersLetter.filter(its => {
                  let zm = its.replace('(', '').replace(')', '')
                  pattern = pattern.replaceAll(its, zm)
                })
              }
              let replaceStr = {
                '÷': '/',
                'x': '*',
                '{': '(',
                '}': ')',
                '[': '(',
                ']': ')',
              }
  
              for(let i in replaceStr) {
                pattern = pattern.replaceAll(i, replaceStr[i])
              }
              console.log(pattern)
              form.choices.push({value: pattern})
            }
          })
        } catch(e) {
          console.log(e)
        }
      }
      let res = topic.match(regex)
      let regexMap = {
        over: /.*\$.*over.*\$.*/,
        frac: /.*\$.*frac.*\$.*/
      }
      console.log(res)
      res && res.filter((its) => {
        its = its.replaceAll('&nbsp;', '').replace(/ /g, "")
        // 分數
        if(its.match(regexMap.over) || its.match(regexMap.frac)) {
          let arr = its.match(/\d+/g)
          arr.filter(item => {
            form.answers.push({value: item.replaceAll(pLeft, '\\left(').replaceAll(pRight, '\\right)')})
            form.choices.push({value: ''})
          })
          fillList.push({value: its})
        } else {
          form.answers.push({value: its.substring(1, its.length - 1).replaceAll(pLeft, '\\left(').replaceAll(pRight, '\\right)')})
          form.choices.push({value: ''})
          fillList.push({value: its.substring(1, its.length - 1)})
        }
      })

      form.content = JSON.stringify({
        topic: this.topic.replaceAll('\\left(', pLeft).replaceAll('\\right)', pRight), fillList
      })

      return form
    },
    // 提交
    onSubmit() {
      let form = this.handleFromData()
      // type, type_display
      console.log(form)
      this.$emit('save', form, 2, 2)
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
      // this.$router.go(-1)
    },

    // 处理編輯數据
    handleEditData() {
      let {content} = this.rulesForm,
      {fillList, topic} = JSON.parse(content)

      fillList.filter((its) => {
        topic = topic.replace(`(${its.label})`, `(${its.value})`)
      })

      this.topic = topic.replaceAll(pLeft, '\\left(').replaceAll(pRight, '\\right)')
    }
  },
  created() {
    this.rulesForm = {...this.formLabelAlign}
  },
  mounted() {

    if(this.rulesForm.answers.length > 0) {
      this.handleEditData()
    }
    let Tinymce = this.$refs.Tinymce.$el,
    target = null

    setTimeout(() => {
      lx(Tinymce)

      let body = target.contentDocument.body
      body.onfocus = () => {
        let {top, left} = getNodeOffset(Tinymce)
        , box = document.querySelector('.mathematical-mathjax')
        box.style = `
          left: ${left}px;
          width: ${Tinymce.offsetWidth}px;
          display: flex;
        `
        box.style.top = `${top - box.offsetHeight}px`
      }

      body.onblur = () => {
        let box = document.querySelector('.mathematical-mathjax')
        box.style.display = 'none'
      }
    }, 1000)

    function lx (parent) {
      if(parent.tagName == 'IFRAME') target = parent

      for(let i = 0; parent.childNodes && i < parent.childNodes.length; i++) {
        let node = parent.childNodes[i]
        lx(node)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select {
  margin: 0;
  padding-left: 0px;
  
  .option {
    list-style-type: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .key {
      font-size: 16px;
      color: #a5a5a5;
      width: 50px;
    }
    .val {
      font-size: 16px;
      color: #a5a5a5;
      margin-left: 16px;
    }
    .fill {
      margin-right: 10px;
      .label {
        width: 50px;
      }

      .value {
        width: 100px;
      }
    }

  }
}

.mathematical-mathjax {
  position: absolute;
  top: 350px;
  left: 50px;
  width: 270px;
  height: 200px;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px 0 10px 10px;
  display: flex;
  overflow-y: auto;
  justify-content: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  box-shadow: 1px 1px 2px 1px #ccc;
  box-sizing: border-box;
  z-index: 999;
  display: none;

  .symbol {
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;

    &:hover {
      background-color: #eee;
    }
  }
}
</style>
<style lang="scss" >
.gap-filling {
  .ordinary {
    color: #333;
    margin: 5px 0;
  }
  .ordinary.fill {
    border-radius: 10px;
    background-color: #fcd2ab;
    outline: none;
    border: none;
    width: 100px;
    height: 40px;
    text-align: center;
    padding: 5px;
    box-sizing: border-box;
    font-size: 16px;
  }

  .overline {
    display: flex;
    align-items: center;
    margin-top: 5px;

    .overline-content {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #333;
      }
    }
  }

  .some-as {
    display: inline-block;
    margin: 0 5px;
    position: relative;
    color: #333;
    vertical-align: middle;

    &:after {
      // content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 1px;
      width: 100%;
      background-color: #333;
    }

    .some-child {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
    }

    .line {
      display: block;
      width: inherit;
      min-width: 30px;
      height: 1px;
      background-color: #333;
    }

    .numerator, .denominator {
      margin: 5px 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
    }

    .numerator.fill, .denominator.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      width: 100px;
      height: 40px;
      text-align: center;
      padding: 5px;
      box-sizing: border-box;
    }
  }

  .mixed-number {
    display: inline-flex;
    align-items: center;
    .mixed {
      color: #333;
    }

    .mixed.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      width: 60px;
      height: 40px;
      text-align: center;
      padding: 5px;
      color: #333;
    }
  } 
}

.mathematical-mathjax {
  .numerator {
    // height: 50px !important;
  }
  .some-child > span {
    display: flex;
    align-items: center;
  }
}
</style>